export const DEFAULT_THEME = {
  name: 'default',
  base: null,
  variables: { }
};
